module.exports = __webpack_public_path__ + "static/media/WE-Logo.a6056d5d.png";